import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import Loader from '../utility/Loader';
import authservice from '../Authentication/service/authservice';
import debounce from 'lodash/debounce';
import ClipAd from '../advertisements/ClipAd';
import ClipContentMob from './ClipContentMob';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

class CLipShareListingMobile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clipCache: [],
            subCategories: [],
            currentIndex: 0,
            activeSlide: 1,
            translateY: 0,
            animating: false,
            startY: 0,
            error: null,
            showAd: false,
            numberOfDownSwap: 1,
            isNextButtonDisabled: false,
            isSwipeDisabled: false,
            adViewTimestamps: {}
        };
        this.startY = 0;
        this.handleTouchEndDebounced = debounce(this.handleTouchEnd, 200);
        // this.viewTimer = null;
        this.adTimer = null;
    }

    preventScroll = function (e) {
        if (e.touches.length > 1) return;
        e.preventDefault();
    };

    componentDidMount() {
        this.clearClip()
        window.scrollTo(0, 0);
        this.callClipDetails(this.props.match.params.hpId);
        window.addEventListener('touchstart', this.handleTouchStart);
        window.addEventListener('touchend', this.handleTouchEnd);
        const container = document.querySelector('.clip-viewport');
        if (container) {
            container.addEventListener('touchmove', this.preventScroll, { passive: false });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('touchstart', this.handleTouchStart);
        window.removeEventListener('touchend', this.handleTouchEnd);
        clearTimeout(this.adTimer);
        const container = document.querySelector('.clip-viewport');
        if (container) {
            container.removeEventListener('touchmove', this.preventScroll);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.currentIndex !== prevState.currentIndex) {
            window.scrollTo(0, 0);
            this.handleAdSwipeLock();
        }
    }

    handleAdSwipeLock = () => {
        const clipWithAds = this.getClipWithAds();
        const currentItem = clipWithAds[this.state.currentIndex];

        if (currentItem && currentItem.type === 'ad') {
            const adKey = `ad-${this.state.currentIndex}`;

            if (!this.state.adViewTimestamps[adKey]) {
                this.setState({ isSwipeDisabled: true });

                clearTimeout(this.adTimer);
                this.adTimer = setTimeout(() => {
                    this.setState(prevState => ({
                        isSwipeDisabled: false,
                        adViewTimestamps: {
                            ...prevState.adViewTimestamps,
                            [adKey]: true
                        }
                    }));
                }, 30000);
            } else {
                // Already viewed 30s before
                this.setState({ isSwipeDisabled: false });
            }
        } else {
            this.setState({ isSwipeDisabled: false });
        }
    }


    clearClip = () => {
        if (this.props.is_login) {
            axios.post(process.env.REACT_APP_BACKEND_URL + `/user-activity/clear-trash-memory?${'userId=' + authservice.getCurrentUserid()}`).then(response => {
                this.setState({ clipListing: response.data });
            }).catch(error => {
                Loader.stopSpinner();
                if (error.response)
                    this.setState({ error: error.response.data })
            })
        }
        else {
            axios.post(process.env.REACT_APP_BACKEND_URL + `/guest-activity/clear-trash-memory?${'guestId=' + authservice.getCookie('hp.rocks.soon')}`).then(response => {
                this.setState({ clipListing: response.data });
            }).catch(error => {
                Loader.stopSpinner();
                if (error.response)
                    this.setState({ error: error.response.data })
            })
        }
    }

    handleTouchStart = (e) => {
        if (this.state.animating) return;
        this.setState({ startY: e.touches[0].clientY });
    };

    handleTouchMove = (e) => {
        if (this.state.animating) return;

        const deltaY = e.touches[0].clientY - this.state.startY;
        this.setState({ translateY: deltaY }); // move clip as finger moves
    };

    getClipWithAds = () => {
        const { clipCache } = this.state;
        const clipWithAds = [];

        const adFrequency = 5; // Show ad after every 5 clips
        const totalClips = clipCache.length;

        clipCache.forEach((clip, index) => {
            clipWithAds.push({ type: 'clip', data: clip });

            const isAdSlot = (index + 1) % adFrequency === 0;

            if (isAdSlot) {
                // Insert ad after every 5 clips
                clipWithAds.push({ type: 'ad', data: null });
            }

            if (index === totalClips - 1) {
                // Always add a final ad after the last clip if it wasn't just added
                const lastItem = clipWithAds[clipWithAds.length - 1];
                if (!(lastItem.type === 'ad')) {
                    clipWithAds.push({ type: 'ad', data: null });
                }
            }
        });

        return clipWithAds;
    };


    handleTouchEnd = () => {
        const { translateY, currentIndex, clipCache } = this.state;
        const clipWithAds = this.getClipWithAds();

        const threshold = 100; // minimum px to trigger swipe

        if (this.state.isSwipeDisabled) {
            console.log("Swipe disabled: Ad is still playing.");
            this.setState({ translateY: 0 });
            return;
        }


        if (translateY < -threshold && currentIndex < clipWithAds.length - 1) {
            // Swipe Up → Next Clip

            this.setState({ showAd: false });
            this.setState({ animating: true, translateY: -window.innerHeight }, () => {
                setTimeout(() => {
                    this.setState({
                        currentIndex: currentIndex + 1,
                        translateY: 0,
                        animating: false,
                    }, () => {
                        if (this.state.currentIndex === this.state.clipCache.length - 1) {
                            this.fetchClipFromServer();
                        }
                        this.updateURL();
                    });
                }, 300);
            });
        } else if (translateY > threshold && currentIndex > 0) {
            this.resetAllVideos();
            // Swipe Down → Prev Clip
            this.setState({ animating: true, translateY: window.innerHeight }, () => {
                setTimeout(() => {
                    this.setState({
                        currentIndex: currentIndex - 1,
                        translateY: 0,
                        animating: false,
                    }, this.updateURL);
                }, 300);
            });
        } else {
            // Not enough movement → Snap back
            this.setState({ animating: true, translateY: 0 }, () => {
                setTimeout(() => this.setState({ animating: false }), 300);
            });
        }
    };

    resetAllVideos = () => {
        const videos = document.querySelectorAll('video');
        videos.forEach(video => {
            if (!video) return;

            const container = video.closest('.clip-container');
            const isVisible = container && container.offsetTop === window.scrollY;

            if (!isVisible) {
                video.pause();
                video.muted = true;
                video.currentTime = 0;
            }
        });
    };

    updateURL = () => {
        const clipWithAds = this.getClipWithAds();
        const { currentIndex } = this.state;
        const currentItem = clipWithAds[currentIndex];

        if (currentItem && currentItem.type === 'clip') {
            const clipListing = currentItem.data.clipListing;
            if (clipListing && clipListing.businessName) {
                const businessName = clipListing.businessName.replace(/[^\w\s^&]/gm, ' ').trim().replace(/[\s]/gm, '-');
                this.props.history.push(`/shareclips/${businessName}/${clipListing.hpId}`);
            }
        }
    };

    callClipDetails = (hpId) => {
        const url = `${process.env.REACT_APP_BACKEND_URL}/hpmgr/listing/getlistings/${hpId}?${this.props.is_login ? 'user_id=' + authservice.getCurrentUserid() : 'guest_id=' + authservice.getCookie('hp.rocks.soon')}`;

        axios.get(url)
            .then(response => {
                const clipCache = [];
                const subCategories = []
                clipCache.push({
                    clipListing: response.data,
                    subCategories: response.data.subCategories
                });
                this.setState({ subCategories: response.data.subCategories })
                this.setState({ clipCache, subCategories }, () => this.fetchClipFromServer()); // Call loadNextClip after setting initial clip data
            })
            .catch(error => {
                Loader.stopSpinner();
                if (error.response)
                    this.setState({ error: error.response.data });
            });
    }

    fetchClipFromServer = () => {
        console.log("fetching more clips from server")
        const { clipCache, currentIndex } = this.state;
        const currentClipData = clipCache[currentIndex];
        {
            currentClipData.subCategories.map((subcategory) => {
                axios.get(`${process.env.REACT_APP_BACKEND_URL}/hpmgr/listing/next-clips?${'subCategory=' + subcategory.subCategory}&${this.props.is_login ? 'user_id=' + authservice.getCurrentUserid() : 'guest_id=' + authservice.getCookie('hp.rocks.soon')}`)
                    .then(response => {
                        const nextClipListing = response.data;
                        localStorage.removeItem("clipad")
                        if (nextClipListing && nextClipListing.subCategories && nextClipListing.subCategories.length > 0) {
                            const nextClipData = {
                                clipListing: nextClipListing,
                                subCategories: nextClipListing.subCategories
                            };
                            this.setState(prevState => ({
                                clipCache: [...prevState.clipCache, nextClipData]
                            }));
                        } else {
                            console.log("No next clips available.");
                        }
                    })
                    .catch(error => {
                        Loader.stopSpinner();
                        console.error('Error fetching next clip:', error);
                        if (error.response)
                            this.setState({ error: error.response.data });
                    });
            })
        }
    }

    resetAllVideos = () => {
        const videos = document.querySelectorAll('video');
        videos.forEach(video => {
            if (!video) return;

            const container = video.closest('.clip-container');
            const isVisible = container && container.offsetTop === window.scrollY;

            if (!isVisible) {
                video.pause();
                video.muted = true;
                video.currentTime = 0;
            }
        });
    };

    // handleAdLoadFail = () => {
    //     this.setState({ isSwipeDisabled: false });
    // };

    render() {
        const { clipCache, currentIndex } = this.state;
        const currentClipData = clipCache[currentIndex];

        const clipWithAds = this.getClipWithAds();

        return (
            <div className='clipListingMobile'>
                {this.state.showAd
                    ? <>
                        <div style={{ position: 'absolute', top: '18px', left: '18px' }}>
                            <Link to='/' style={{ position: 'absolute' }}><i style={{ fontSize: '45px' }} className="fa fa-home home_link styled-icon"></i></Link>
                        </div>
                        <div className='text-center'>
                            <ClipAd spot={"-1"} />
                        </div>
                    </>
                    : <div className="clip-viewport"
                        onTouchStart={this.handleTouchStart}
                        onTouchMove={this.handleTouchMove}
                        onTouchEnd={this.handleTouchEnd}
                    >
                        <div className="clip-wrapper"
                            style={{
                                transform: `translateY(calc(-${this.state.currentIndex * 100}vh + ${this.state.translateY}px))`,
                                transition: this.state.animating ? 'transform 0.3s ease' : 'none',
                            }}
                        >
                            {clipWithAds.map((item, index) => (
                                <div className="clip-container" key={index}>
                                    {item.type === 'clip' ? (
                                        <ClipContentMob listing={item.data.clipListing} isActive={index === this.state.currentIndex} />
                                    )
                                        : (
                                            <ClipAd
                                                spot={`ad-${index}`}
                                                isActive={index === this.state.currentIndex}
                                                clipId={
                                                    index > 0 && clipWithAds[index - 1].type === 'clip'
                                                        ? clipWithAds[index - 1].data.clipListing.hpId
                                                        : null
                                                }
                                            // content_page="ClipsPage"
                                            // search_data={this.props.search_data}
                                            // viewedAds={this.props.viewedAds}
                                            // onAdFail={this.handleAdLoadFail}
                                            />
                                        )}

                                </div>
                            ))}
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    is_login: state.is_login,
    listing_id: state.listing_id,
    viewedListings: state.viewedListings,
    search_data: state.search_data,
    clipadAds: state.clipadAds,
    visibleAds: state.visibleAds,
});

export default connect(mapStateToProps)(CLipShareListingMobile);
